/* Compact mobile controls delegate to Horizon's original option inputs. */
(() => {
  class AureliaPicker extends HTMLElement {
    connectedCallback() {
      if(this.abort)return;
      this.abort=new AbortController();
      const signal=this.abort.signal;
      const choose=(index,value)=>{
        const picker=this.parentElement.querySelector(`variant-picker[data-product-id="${this.dataset.productId}"]`);
        const input=[...(picker?.querySelectorAll(`input[data-fieldset-index="${index}"]`)||[])].find(x=>x.value===value);
        if(input&&!input.checked)input.click();
      };
      this.addEventListener('click',event=>{
        const button=event.target.closest('[data-lv-compact-colour]');
        if(!button)return;
        choose(button.dataset.lvOptionIndex,button.dataset.lvCompactColour);
        button.closest('details').open=false;
      },{signal});
      document.addEventListener('pointerdown',event=>{if(!this.contains(event.target))this.querySelectorAll('details[open]').forEach(x=>x.open=false);},{signal});
      this.addEventListener('keydown',event=>{if(event.key==='Escape'){const details=this.querySelector('details[open]');if(details){details.open=false;details.querySelector('summary').focus();}}},{signal});
      this.addEventListener('change',event=>{
        const select=event.target.closest('[data-lv-compact-option]');
        if(!select)return;
        choose(select.dataset.lvCompactOption,select.value);
      },{signal:this.abort.signal});
      this.sync=()=>{
        const picker=this.parentElement.querySelector(`variant-picker[data-product-id="${this.dataset.productId}"]`);
        this.querySelectorAll('[data-lv-compact-option]').forEach(select=>{
          const input=picker?.querySelector(`input[data-fieldset-index="${select.dataset.lvCompactOption}"]:checked`);
          if(input&&select.value!==input.value)select.value=input.value;
        });
        this.querySelectorAll('[data-lv-compact-colour]').forEach(button=>{
          const input=picker?.querySelector(`input[data-fieldset-index="${button.dataset.lvOptionIndex}"]:checked`);
          const selected=input?.value===button.dataset.lvCompactColour;
          if(button.getAttribute('aria-pressed')!==String(selected))button.setAttribute('aria-pressed',String(selected));
          if(selected){
            const label=this.querySelector('[data-lv-compact-colour-label]');
            if(label&&label.textContent!==input.value)label.textContent=input.value;
            const src=button.querySelector('img')?.getAttribute('src'),image=this.querySelector('.lv-compact-colour-current-image');
            if(src&&image&&image.getAttribute('src')!==src){image.removeAttribute('srcset');image.setAttribute('src',src);}
          }
        });
        // A quick colour + size change can leave Horizon's early URL at the old
        // colour. Use the resolved native variant only after its options match.
        try {
          const variant=JSON.parse(picker?.querySelector('script[type="application/json"]')?.textContent||'null');
          const checked=[...(picker?.querySelectorAll('fieldset input:checked')||[])].map(x=>x.value);
          if(variant?.id&&Array.isArray(variant.options)&&variant.options.length===checked.length&&variant.options.every((x,i)=>x===checked[i])){
            const url=new URL(location.href);
            if(url.searchParams.get('variant')!==String(variant.id)){
              url.searchParams.set('variant',String(variant.id));history.replaceState(history.state,'',url);
            }
          }
        } catch { /* Native variant error/availability UI remains authoritative. */ }
      };
      this.observer=new MutationObserver(this.sync);
      this.observer.observe(this.parentElement,{childList:true,subtree:true});
      this.sync();
    }
    disconnectedCallback(){this.abort?.abort();this.abort=null;this.observer?.disconnect();}
  }
  if(!customElements.get('livarelle-aurelia-picker'))customElements.define('livarelle-aurelia-picker',AureliaPicker);
  document.addEventListener('click',event=>{
    if(!event.target.closest('[data-lv-aurelia-guide]'))return;
    const details=event.target.closest('.lv-pdp-purchase') || document.querySelector('.lv-pdp-purchase');
    const selected=details?.querySelector('[data-lv-size-fieldset] input:checked')?.value;
    details?.querySelector('livarelle-size-guide')?.open(selected,'standard');
  });
})();

